import {MemberService} from "../resource";

const MemberModule = {
	namespaced: true,
	state: {
		datas: [],
		memberCoupons: [],
		currentMember: null,
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		},
		SET_MEMBER_COUPONS(state, data) {
			state.memberCoupons = data;
		},
		SET_CURRENT_MEMBER(state, data) {
			state.currentMember = data;
		}
	},
	actions: {
		createData({ commit, state }, params) {
			return MemberService.MemberCreate(params);
		},

		updateData({ commit, state }, params) {
			return MemberService.MemberUpdate(params.id, params.payload);
		},

		deleteData({ commit, state }, params) {
			return MemberService.MemberDelete(params);
		},

		async listData({ commit, state }, params) {
			try {
				const response = await MemberService.MemberList(params);
				commit("SET_DATA", response.data.Datum.data);
			} catch (error) {
				commit("SET_DATA", []);
			}
		},

		async getData({ commit, state }, id) {
			try {
				const response = await MemberService.MemberGet(id);
				commit("SET_CURRENT_MEMBER", response.data);
				return response.data;
			} catch (error) {
				commit("SET_CURRENT_MEMBER", null);
				throw error;
			}
		},

		async getMemberCoupons({ commit, state }, params) {
			try {
				const response = await MemberService.MemberGetCoupons(params.id, params.params);
				commit("SET_MEMBER_COUPONS", response.data.coupons);
				return response.data;
			} catch (error) {
				commit("SET_MEMBER_COUPONS", []);
				throw error;
			}
		},

		async listMemberCoupons({ commit, state }, params) {
			try {
				const response = await MemberService.MemberCouponList(params);
				return response.data;
			} catch (error) {
				throw error;
			}
		},

		assignCoupon({ commit, state }, params) {
			return MemberService.MemberCouponAssign(params);
		},

		removeCouponAssignment({ commit, state }, id) {
			return MemberService.MemberCouponRemove(id);
		}
	},
	getters: {
		getData(state) {
			return state.datas;
		},
		getMemberCoupons(state) {
			return state.memberCoupons;
		},
		getCurrentMember(state) {
			return state.currentMember;
		},
		getStatusTable(state) {
			return [
				{name: "Non-verified phone", id: 0},
				{name: "Normal (verified)", id: 1},
				{name: "Blocked", id: 2},
			];
		},
		getStatusTableWithAll(state) {
			return [
				{name: "--- Status ---", id: -1},
				{name: "Non-verified phone", id: 0},
				{name: "Normal (verified)", id: 1},
				{name: "Blocked", id: 2},
			];
		},
		getSexTable(state) {
			return [
				{name: "Not specified", id: 0},
				{name: "Unknown", id: 1},
				{name: "Male", id: 2},
				{name: "Female", id: 3},
			];
		}
	},
};

export default MemberModule;